import * as React from "react";
import { Container, Icon } from "./Styled";
import { Popover } from "antd";
import { IoMdMore } from 'react-icons/io';
import { AiOutlineDelete } from "react-icons/ai";
import Item from "./item/Item";
type OptionsToolTipProps = {
    onDelete:() => void;
};

export const OptionsToolTip: React.FunctionComponent<OptionsToolTipProps> = ({
  onDelete
}) => {

  const content = (
    <div>
      <Item icon={<AiOutlineDelete size={15}/>} label="Supprimer" onSelect={onDelete}></Item>
    </div>
  );

  return (
    <>
      <Popover content={content} 
               title="Options"
               trigger="click">
        <Container>
            <Icon><IoMdMore size={20}/></Icon>
        </Container>
      </Popover>
    </>
  );
};
